import { ILineItemForm } from '@/Interfaces/CampaignManagement/LineItem.interface';
import { IDV360TicketsLineItemForm } from '@/Interfaces/DV360Tickets/LineItem.interface';
import LineItemSummaryService, { type IBasicInfoRow } from '@/Services/CampaignManagement/LineItemSummary.service';
import { numberToUsFormat, numberToUsd } from '@/helpers/valueFormatter/numberFormatter.helpers';

export default class DV360TicketsLineItemSummaryService extends LineItemSummaryService {
  public static getBasicInfo(formValues: ILineItemForm): IBasicInfoRow[] {
    const dv360FormValues = formValues as unknown as IDV360TicketsLineItemForm;
    const parseAmount = (value: number | string | null | undefined) =>
      value === null || value === undefined || value === '' ? null : Number(value);
    const parsedBudget = parseAmount(dv360FormValues.budget);
    const parsedBidCpm = parseAmount(dv360FormValues.bidCpm);

    return [
      { label: 'Line Item Name', value: dv360FormValues.name },
      {
        label: 'Wholesale Budget',
        value: parsedBudget !== null && Number.isFinite(parsedBudget) ? numberToUsFormat(parsedBudget) : null,
      },
      {
        label: 'Bid CPM',
        value: parsedBidCpm !== null && Number.isFinite(parsedBidCpm) ? numberToUsd(parsedBidCpm) : null,
      },
      { label: 'Start Date - End Date', value: this.getDateRange(dv360FormValues.startDate, dv360FormValues.endDate) },
      { label: 'Product', value: dv360FormValues.product?.name },
    ].filter(row => !!row?.value);
  }
}
